export enum ContactPreferredTimeEnum {
  BeforeNoon = 'beforeNoon',
  Noon = 'noon',
  Afternoon = 'afternoon',
  Evening = 'evening',
  AllDay = 'allDay',
}
